/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type PropsWithChildren } from 'react';

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ActionCardWrapper } from '../../common/ui/action-card-wrapper';

import messages from './messages';

const styles = cssMap({
	cardHoverShadow: {
		borderRadius: token('radius.xlarge'),
		transition: 'box-shadow 0.15s ease-in-out',
		'&:hover': {
			boxShadow: token('elevation.shadow.overlay'),
		},
	},
});

export const FocusAskActionCardWrapper = ({ children }: PropsWithChildren): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.cardHoverShadow}>
			<ActionCardWrapper
				isExpandable
				isTitleBold
				title={formatMessage(messages.cardTitle)}
				product="focus-ask"
			>
				{children}
			</ActionCardWrapper>
		</Box>
	);
};
